import { Injectable } from '@angular/core';
import { cloneDeep, filter, map } from 'lodash';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { loadWizards } from '../../../../../wizard/src/lib/wizard/json';
import { UserAuth } from '../user/user.auth';
import { UserService } from '../user/user.service';

const defaultLayout = require('./mocks/system.default.json');
const registryDataSource = require('./mocks/registry.data.source.default.json');
const registryPerspective = require('./mocks/registry.perspective.default.json');
const registryTemplate = require('./mocks/registry.widget.template.default.json');

@Injectable({
  providedIn: 'root'
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class AtwebLayoutProviderService implements Resolve<any> {
  url = '/workflow/layout/end-user-layout/4WjPI';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newLayout: any;
  activeLayout = null;
  currentPerspectiveId: string = null;

  constructor(private readonly userAuth: UserAuth, private readonly userService: UserService) {
    // this is not enough to be sure we have necessary layout downloaded
    this.userService.profileEvents.subscribe(event => {
      // skip dummy objects on subscription
      if (event.event && event.event === 'login') {
        // simulate triggering download of config upon successful login event
        this.downloadLayout(userAuth.getUserAuth());
      }
    });
  }

  // eslint-disable-next-line
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    // normally, we'd register a then listener on downloadLayout
    this.downloadLayout(this.userAuth.getUserAuth());

    return this.getLayout();
  }

  // eslint-disable-next-line
  downloadLayout(userInfo: UserAuth): Promise<any> {
    // const userName = get(
    //   userInfo.data,
    //   'FIRST_NAME',
    //   userInfo.getUserEmail()
    // );

    // GLiles - We do not save custom home pages for each user.
    // I am commenting out this logic for now until we do support them.
    /*
    return new Promise(resolve => {
      this.httpClient.get(this.url).subscribe(
        (result) => {
          this.newLayout = result;
          this.activeLayout = cloneDeep(this.newLayout);
          this.currentPerspectiveId = this.activeLayout.workspaces[0].settings.activePerspective;

          return resolve(this.activeLayout);
        },
        (failure) => {
          console.log('failed to download user-specific layout.', failure);
          return this.defaultHomepage();
      });
    });
    */

    // GLiles - For now show the default home page. Remove this when we support custom home pages
    return this.defaultHomepage();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultHomepage(): Promise<any> {
    return new Promise(resolve => {
      this.newLayout = defaultLayout;
      this.newLayout.workspaces[0].registry.data_source = registryDataSource;
      this.newLayout.workspaces[0].registry.perspective = registryPerspective;
      this.newLayout.workspaces[0].registry.widget_template = registryTemplate;
      this.newLayout.workspaces[0].registry.wizard = loadWizards();
      this.activeLayout = cloneDeep(this.newLayout);
      this.currentPerspectiveId = this.activeLayout.workspaces[0].settings.activePerspective;

      return resolve(this.activeLayout);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getLayout(): Promise<any> {
    if (this.activeLayout) {
      return Promise.resolve(this.activeLayout.workspaces[0]);
    } else {
      return this.downloadLayout(this.userAuth.getUserAuth()).then(value => {
        return value.workspaces[0];
      });
    }
  }

  setCurrentPerspective(perspectiveId: string): void {
    this.currentPerspectiveId = perspectiveId;
  }

  getCurrentPerspective(): string {
    return this.currentPerspectiveId;
  }

  // eslint-disable-next-line
  lookupByRef(ref: any): void {
    // right now only routed_area object lookup
    switch (ref.object) {
      case 'routed-view': {
        const hostAreas = this.activeLayout.workspaces[0].registry.perspective[
          this.currentPerspectiveId
        ].areas;
        let result = filter(hostAreas, item => {
          return item.routed_view && item.routed_view.id === ref.id;
        });
        result = map(result, 'routed_view');
        // and we need the first one/others should not exist as id must be uniq
        return result[0];
      }
      default: {
        // eslint-disable-next-line no-console
        console.log('NOT implemented yet', ref.object);
      }
    }
  }

  // eslint-disable-next-line
  updateViewInLayout(view: any): void {
    const id = view.id;
    this.activeLayout.workspaces[0].registry.view[id] = view;
  }
}
